var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDistance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "#000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1176_190)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.19287 6.15381C0.177734 6.14844 -0.0102539 4.88623 0.881348 4.47803L9.48047 0.519531C10.4688 0.0683594 11.2476 0.771973 10.7803 1.78174L6.83789 10.3433C6.39746 11.2993 5.13525 11.0791 5.13525 10.0801L5.12451 6.23975C5.12451 6.16992 5.11377 6.16455 5.04932 6.16455L1.19287 6.15381Z",
    fill: "#FFFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1176_190"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistance);
export default __webpack_public_path__ + "static/media/distance.78d31c184372ce6668392c1f44559020.svg";
export { ForwardRef as ReactComponent };